import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';

import RatePresenter, {
  RATES_TYPE,
} from '../../../../../../presenters/RatePresenter';

import RateTable from './components/RateTable';

const RateList = (props) => {
  const { rates, rateType } = props;

  const tableBoxClassName =
    rateType == RATES_TYPE.birthday ? 'birthday-rates-table' : '';
  const tableName =
    rateType == RATES_TYPE.default ? 'Default rates' : 'Birthday rates';

  return isEmpty(rates) ? (
    <div className={`no-${rateType}-rates-message`}>
      {`No ${rateType} rates yet`}
    </div>
  ) : (
    <div className={tableBoxClassName}>
      <div className="rate-table-caption">{tableName}</div>
      <RateTable rates={rates} />
    </div>
  );
};

export default RateList;

RateList.propTypes = {
  rates: PropTypes.arrayOf(RatePresenter.shape()),
  rateType: PropTypes.string.isRequired,
};

RateList.defaultProps = {
  rates: [],
};
